module.exports = __webpack_public_path__ + "img/icon_calendar.1ef61973.svg";